import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getGroceryReceipt = async (orderId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      orderId,
    },
    query: graphql(`
      query GetGroceryReceipt($orderId: String!) {
        getGroceryReceipt(orderId: $orderId)
      }
    `),
  });

  return response.data.getGroceryReceipt;
};
